import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'
import ReactHtmlParser from 'html-react-parser';

import type { GetSummaryType } from '../../../types/GetSummary'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    padding 8px;
`;

interface SummaryProps {
    summary: GetSummaryType;
}

const Summary: React.FC<SummaryProps> = ({ summary }) => {

    return (
        <ThemeProvider theme={theme} >
            <Table cellPadding="0" cellSpacing="0">
                <tbody>
                    <HeaderRow>
                        <td>SUMMARY</td>
                    </HeaderRow>
                    <tr>
                        <td>
                            <Table cellPadding="2" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <TableCell>
                                            {summary && summary.text ? ReactHtmlParser(summary.text) : '\u00A0'}
                                        </TableCell>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </ThemeProvider>
    );
}

export default Summary;